import { generateMonth } from 'app/components/pages/visits/components/calendar/table-month/Utils';

const TEMPLATE_NAME = 'MONTH_VISITS';

/* const dataFormat = data => {
  const resultData = {};

  resultData.months = generateMonth(data.resume) ? generateMonth(data.resume) : [];
  // resultData.visitations = data.visitations ? data.visitations : [];
  // resultData.resume = data.resume ? data.resume : [];

  return resultData;
}; */

const initialState = () => ({
  loading: false,
  loadedData: []
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      const data = action.payload;

      return {
        ...state,
        loading: false,
        loadedData: generateMonth(data) ? generateMonth(data) : []
      };
    }
    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
